import { memo } from 'react';
import { FormControl, FormLabel, FormLabelClassKey } from '@material-ui/core';
import { ClassNameMap } from '@material-ui/styles';

import { Select } from '@components/SharedComponents/DesignSystem/Inputs';

import { Option } from '@types';

import './index.scss';

const classes = {
  root: 'root',
};

interface SelectFormFieldProps {
  label: string;
  value?: string | number;
  onChange: (value: string | number) => void;
  options: Option<string>[];
  // For overwriting material classes
  fieldLabelClasses?: Partial<ClassNameMap<FormLabelClassKey>>;
  dataTestId?: string;
}

// If you find this component and want to reuse it - feel free to do it
export const SelectFormField = memo(
  ({ label, value, onChange, fieldLabelClasses, options, dataTestId }: SelectFormFieldProps) => {
    return (
      <FormControl variant="standard" fullWidth>
        <FormLabel classes={fieldLabelClasses}>{label}</FormLabel>
        <Select
          testId={dataTestId}
          value={value ?? ''}
          options={options}
          handleChange={onChange}
          variant="outlined"
          classes={classes}
        />
      </FormControl>
    );
  }
);

SelectFormField.displayName = 'SelectFormField';
